import { useIntl } from 'react-intl';
import { Chip, Stack } from '@rossum/ui/material';

type TriggerResultColumnProps = {
  triggerConditionResults: boolean[];
};

export const TriggerResultColumn = ({
  triggerConditionResults,
}: TriggerResultColumnProps) => {
  const intl = useIntl();
  const isSingleLine = triggerConditionResults.length === 1;
  const matchCount = triggerConditionResults.filter(Boolean).length;
  const totalCount = triggerConditionResults.length;
  const hasMatches = matchCount > 0;

  const label = isSingleLine
    ? intl.formatMessage({
        id: triggerConditionResults[0]
          ? 'features.rulesExecutionLogs.triggerResult.true'
          : 'features.rulesExecutionLogs.triggerResult.false',
      })
    : `${matchCount}/${totalCount} ${intl
        .formatMessage({
          id: 'features.rulesExecutionLogs.triggerResult.true',
        })
        .toLowerCase()}`;

  return (
    <Stack direction="row" alignItems="center" width="100%">
      <Chip
        label={label}
        size="small"
        color={hasMatches ? 'success' : 'default'}
      />
    </Stack>
  );
};
